export default {
  PUSH_NOTIFICATION_DECISION_KEY: 'riseup.pushNotificationDecision',
  PUSH_NOTIFICATION_REJECTION_DATE_KEY: 'riseup.pushNotificationRejectionDate',
};
